import type { FunctionComponent, TargetedKeyboardEvent } from 'preact';

import isLight from 'Modules/colorLightness';
import { isTruthy } from 'Utils/guards';

interface Props {
  color: string;
  isSelected?: boolean;
  showSwatch?: boolean;
  onClick?: () => void;
  name?: string;
  className?: string;
}

const ColorTile: FunctionComponent<Props> = ({
  color,
  isSelected,
  showSwatch,
  onClick,
  name,
  className: extraClassName,
}) => {
  const onKeyPress = ({ key }: TargetedKeyboardEvent<HTMLDivElement>) => key === 'Enter' && onClick?.();

  const className = [
    'color-tile',
    'grid-square',
    extraClassName,
    isSelected && 'selected',
    showSwatch && 'show-swatch',
    isLight(color) && 'light',
  ]
    .filter(isTruthy)
    .join(' ');

  const props = {
    className,
    style: color ? { backgroundColor: `#${color}` } : undefined,
    title: name,
    onClick,
    onKeyPress,
  };
  return <div {...props} />;
};

export default ColorTile;
